/**
 * Configuracao vinda do ambiente. Falha cedo e alto: um app publicado sem
 * credencial de backend parece funcionar offline e so revela o problema quando
 * a equipe tenta sincronizar, ja de volta do haras.
 */
const required = (key: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(
      `Variavel ${key} nao configurada. Copie .env.example para .env e preencha antes de rodar.`,
    );
  }
  return value;
};

const previa = import.meta.env.VITE_PREVIA === '1';

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  appVersion: import.meta.env.VITE_APP_VERSION ?? 'dev',

  /**
   * Build de previa (`pnpm build:previa`, arquivo .env.previa): app publicado
   * sem login para mostrar e testar antes de haver Supabase. O que se cadastra
   * fica so no aparelho. Build separada; a de producao nunca liga isto.
   */
  previa,

  /**
   * App sem login. Em desenvolvimento, com VITE_DEV_SEM_LOGIN=1 no .env local;
   * fora dele, so na build de previa. A build de producao ignora o flag de dev.
   */
  semLogin: (import.meta.env.DEV && import.meta.env.VITE_DEV_SEM_LOGIN === '1') || previa,
};
